<template>
  
  <v-container fill-height fluid>
    <v-row>
      <v-col align="center"  >
          
          <h3>即將前往問卷頁面</h3>
          <br>
          <v-btn rounded color="primary" @click="goToSurvey()">前往</v-btn>
      </v-col>
      
    </v-row>

  </v-container>
</template>

<script>
// @ is an alias to /src
let surverUrl = process.env.VUE_APP_NP_SURVEY_URL;

export default {
  name: 'SurveyRedirect',
  components: {
  },

  mounted () {
    let params = new URLSearchParams(window.location.search.substring(1));
    let callbackUrlEncoded = params.get("callback_url");
    console.log(decodeURIComponent(callbackUrlEncoded));
    localStorage.setItem("surveryCallback", decodeURIComponent(callbackUrlEncoded) + window.location.hash);
    // window.location.replace(surverUrl);
    // alert(surverUrl);
    liff.openWindow({url: surverUrl, external: false});
    
    console.log(this.isMobile());
  },
  methods: {
    goToSurvey() {
      console.log("go")
      if (this.isMobile()){
        liff.openWindow({url: surverUrl, external: false});
      } else {
        window.location.replace(surverUrl);
      }
      
    },
    isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
}
</script>
